<template>
  <el-dialog width="1150px" :visible="isShow" :close-on-click-modal="false" :modal-append-to-body="false" :append-to-body="true" :show-close="false">
    <div slot="title" class="dialog-title-container">
      <span class="title-label"><i class="el-icon-document"></i> 外协单表单</span>
      <i class="el-icon-error" @click="close"></i>
    </div>
    <el-row class="form-top-btns">
      <el-button type="danger" size="mini" plain round icon="el-icon-close" @click="close">关闭</el-button>
    </el-row>
    <div class="dialog-main-container" style="height:600px">
      <el-form ref="form" :model="formData" size="mini" label-width="80px">
        <div class="form-main">
          <el-row>
            <el-col :span="6">
              <el-form-item label="外协日期" required>
                 <span>{{formData.date}}</span>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="样本册" required>
                <span>{{formData.product_name}}</span>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="外协商" required>
                <span>{{formData.company_name}}</span>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="外协单号">
                <span>{{formData.order_no}}</span>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
              <el-col :span="6">
              <el-form-item label="备注">
                <span>{{formData.remark}}</span>
              </el-form-item>
            </el-col>
          </el-row>
        </div>
        <div style="height: 28px; padding-top: 5px;">
          <div style="border-box; padding:0 5px; width: 70%; height: 100%; float: left;">
            <div class="detail-header">
              <div class="detail-title"><i class="em-icon-th-list"></i> 出库明细</div>
            </div>
          </div>
          <div style="width: 30%; height: 100%; float: right;">
            <div class="detail-header">
              <div class="detail-title"><i class="em-icon-th-list"></i> 样本册附件</div>
            </div>
          </div>
        </div>
        <div class="el-table-container form-details" style="top: 107px;">
          <div style="position: relative; box-size: border-box; padding:0 5px; width: 70%; height: 100%; float: left;">
            <el-table :data="formData.details" size="mini" height="100%" style="width: 100%; border:1px solid #d1d1d1;" border header-row-class-name="list-header-row" row-class-name="list-row">
              <el-table-column label="序号" type="index" width="47" align="center"></el-table-column>
              <el-table-column label="部品名称" prop="base_material_name" width="150" align="center"></el-table-column>
              <el-table-column label="出库数量" prop="current_number" width="60" align="center"></el-table-column>
              <el-table-column label="接收数量" prop="receive_number" width="60" align="center"></el-table-column>
              <el-table-column label="库位" prop="position_value" width="150" align="center"></el-table-column>
              <el-table-column label="出库单号" prop="outstore_no" width="150" align="center"></el-table-column>
              <el-table-column label="出库日期" prop="outstore_date" width="150" align="center"></el-table-column>
              <el-table-column label="异常原因" prop="exception_result" width="200" align="center"></el-table-column>
              <el-table-column label="备注" prop="remark" align="center"></el-table-column>
            </el-table>
          </div>
          <div style="position: relative; width: 30%; height: 100%; float: right;">
            <el-table :data="formData.attaches" size="mini" height="100%" style="width: 100%; border:1px solid #d1d1d1;" border header-row-class-name="list-header-row" row-class-name="list-row">
              <el-table-column label="序号" type="index" width="47" align="center"></el-table-column>
              <el-table-column label="文件名称" prop="file_name" align="center"></el-table-column>
              <el-table-column label="操作" width="50" align="center">
                <template v-slot:default="scope">
                  <el-button type="success" size="mini" icon="el-icon-download" circle @click.stop.prevent="handlerDownload(scope.row.file_url)"></el-button>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
        <div class="form-footer">
          <span>制单人：{{formData.creater_name}}</span>
          <span>制单日期：{{formData.create_time.substring(0,10)}}</span>
        </div>
      </el-form>
    </div>
  </el-dialog>
</template>
<script>
export default {
  name: 'EzzDialogForm',
  props: {
    parent: {
      type: Object,
      default: () => null
    }
  },
  data: function () {
    return {
      // 当前子组件对话框的显隐
      isShow: false,
      formData: null,
      formEmptyData: {
        id: '0',
        order_no: '',
        date: '',
        product_id: '',
        product_name: '',
        company_id: '',
        company_name: '',
        remark: '',
        details: [],
        attaches: [],
        creater_name: sessionStorage.getItem('operator'),
        creater_id: sessionStorage.getItem('operator_id'),
        create_time: ''
      },
      operator_id: sessionStorage.getItem('operator_id'),
      editable: this.$store.state.editable,
      delable: this.$store.state.delable
    }
  },
  beforeCreate: function () {
    var date = new Date()
    var month = date.getMonth() < 9 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1
    var day = date.getDate() <= 9 ? '0' + date.getDate() : date.getDate()
    this.currentDate = date.getFullYear() + '-' + month + '-' + day
  },
  created: function () {
    this.formData = JSON.parse(JSON.stringify(this.formEmptyData))
  },
  mounted: function () {
  },
  methods: {
    // 加载数据
    loadData: function () {
      let _this = this
      _this.post(_this.$apis.getOutsourceOrderForm, { OrderId: _this.formData.id }, function (res) {
        let _json = res.data
        if (_json.status && _json.status === 'logout') {
          _this.logout()
        } else {
          if (_json.formData != null) {
            _this.formData = _json.formData
          } else {
            _this.formData = JSON.parse(JSON.stringify(_this.formEmptyData))
            _this.formData.creater_id = _this.operator_id
            _this.formData.date = _this.currentDate
          }
        }
      })
    },
    close: function () {
      this.$confirm('确定关闭？', '提示', {})
        .then(_ => {
          this.isShow = false
        })
        .catch(_ => {
          return false
        })
    },
    handlerDownload: function (_fileUrl) {
      window.open(this.$apiroot + _fileUrl)
    },
    viewHandler: function (formId) {
      this.formData.id = formId
      this.loadData()
      this.isShow = true
    }
  },
  components: {
  }
}
</script>
